import { axiosInstance } from "apis/_axios";

export const changePasswordApi = (data) =>
  axiosInstance().put("profile/password-change/update", data);

export const resetPasswordMailApi = (data) => {
  return axiosInstance().post("reset-password-mail", data);
};
